/**
 * Created by ZengFanHui on 18/05/16.
 */
import { PAGE_SIZE } from '../utils/config'

/**
 * 表格相关mixin
 * @type {{data: (()), updated: (()), computed: {tableHeight: (())}, methods: {formatterIndex: ((index))}}}
 */
export const tableMixin = {
  data() {
    return {
      filterContainerHeight: 0,
      pageSize: PAGE_SIZE,
      pageIndex: 1
    }
  },
  updated() {
    this.$nextTick(function () {
      let filterContainerHeightDom = document.querySelector('.filter-container')
      if (filterContainerHeightDom) {
        this.filterContainerHeight = filterContainerHeightDom.offsetHeight
      }
    })
  },
  computed: {
    tableHeight() {
      let clientHeight = document.documentElement.clientHeight
      let headerDom = document.querySelector('#header')
      let headerHeight = 0
      if (headerDom) {
        headerHeight = headerDom.offsetHeight
      }
      let tabListDom = document.querySelector('#tabsList')
      let tabHeight = 0
      if (tabListDom) {
        tabHeight = tabListDom.offsetHeight
      }
      // let tableHeight = clientHeight - headerHeight - this.filterContainerHeight - tabHeight - 60 - 51 - 56
      let tableHeight = clientHeight - 60 - 60 - 51 - 56 - 32
      return tableHeight
    }
  },
  methods: {
    formatterIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    formatterIndexNoPage(index) {
      return index + 1
    },
    // OA申请行样式
    oaRowClassName({ row, index }) {
      if (row.remark !== null) {
        return 'text-c-red'
      } else {
        return ''
      }
    }
  }
}
